export default __webpack_public_path__ + "static/media/about dish.9348893e.svg";